var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 22,
    viewBox: "0 0 113 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0703125 0H6.04149L14.2905 11.3487V0H20.2617V21.1807H14.2905L6.04149 9.83199V21.1807H0.0703125V0Z",
    fill: "#011D3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8896 15.7867L38.155 19.0838C36.7396 20.5346 34.0272 21.5501 31.5979 21.5501C26.5155 21.5501 22.9473 18.0683 22.9473 13.1622C22.9473 8.2891 26.4233 4.8667 31.3543 4.8667C36.4631 4.8667 39.4783 8.47374 39.4783 14.613H28.2074C28.6683 16.123 29.8401 17.1122 31.3477 17.1122C32.5459 17.1122 33.8429 16.6176 34.8896 15.7867ZM28.2996 11.5005H34.0864C33.6585 10.175 32.6381 9.31121 31.3477 9.31121C29.9323 9.31121 28.8263 10.175 28.2996 11.5005Z",
    fill: "#011D3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.638 21.1808L49.0836 17.4814L46.4964 21.1808H40.3672L46.0289 13.0435L40.6437 5.24255H46.9243L49.2021 8.53967L51.48 5.24255H57.6092L52.2503 12.9512L57.912 21.1874H51.638V21.1808Z",
    fill: "#011D3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7672 5.24255V21.1808H69.8289V19.5784C68.8414 20.8115 67.2416 21.5501 65.3324 21.5501C61.9156 21.5501 59.4863 18.9915 59.4863 15.3845V5.24255H65.1481V13.9997C65.1481 15.5427 66.1356 16.6176 67.5511 16.6176C68.8743 16.6176 69.8289 15.6021 69.8289 14.1843V5.24255H75.7672Z",
    fill: "#011D3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.167 11.0388V21.2137H99.5056V12.1136C99.5056 10.7552 98.5839 9.79905 97.2606 9.79905C95.9373 9.79905 95.0157 10.6959 95.0157 11.929V21.2071H89.3539V12.1136C89.3539 10.7552 88.4322 9.79905 87.109 9.79905C85.7857 9.79905 84.864 10.6959 84.864 11.929V21.1807H78.9258V5.24244H84.864V7.18774C85.6343 5.76998 87.109 4.87317 88.9918 4.87317C91.0525 4.87317 92.9024 5.8623 93.9821 7.49108C94.9038 5.88868 96.8129 4.87317 99.1566 4.87317C102.462 4.87317 105.167 7.43173 105.167 11.0388Z",
    fill: "#011D3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.803 21.2269C111.218 21.2269 112.364 20.0784 112.364 18.6617C112.364 17.245 111.218 16.0966 109.803 16.0966C108.389 16.0966 107.242 17.245 107.242 18.6617C107.242 20.0784 108.389 21.2269 109.803 21.2269Z",
    fill: "#DD7300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexum);
export default __webpack_public_path__ + "static/media/Nexum.5c2725dc209c1a1b71ab4df22f0104b4.svg";
export { ForwardRef as ReactComponent };